import {
    Dictionary,
    DropDown,
    getMaskFromName,
    ValidatedDropDownList,
    ValidatedInput,
} from '@finbeat/react-toolkit';
import { ClientFilter as FilterType } from 'models/api/client';
import { useTranslation } from 'react-i18next';
import { UseQueryResult } from 'react-query';
import { Col, Row } from 'reactstrap';
import { docMask } from 'utils/masks/docMasks';

export type ClientsFilterProps = {
    brands: DropDown[];
    collectionStatuses: DropDown[];
    getDictsQuery: UseQueryResult<Dictionary<DropDown[]>, unknown>;
};

const ClientFilter = ({ brands, collectionStatuses, getDictsQuery }: ClientsFilterProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col>
                    <ValidatedInput<FilterType>
                        id="ds-id-id"
                        type="number"
                        name="id"
                        label={t('BackOfficeClientId')}
                    />
                </Col>
                <Col>
                    <ValidatedInput<FilterType>
                        id="ds-phone-id"
                        name="phone"
                        maskProps={{
                            mask: getMaskFromName('Uzbekistan'),
                        }}
                        label={t('BackOfficeMobilePhone')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedDropDownList<FilterType>
                        name="brandCode"
                        label={t('BackOfficeBrand')}
                        items={brands}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<FilterType>
                        id="ds-email"
                        name="email"
                        label={t('BackOfficeEmail')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<FilterType>
                        id="ds-doc-num-id"
                        name="docNum"
                        label={t('BackOfficeDocNum')}
                        maskProps={{
                            mask: docMask,
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<FilterType>
                        id="ds-fio-id"
                        name="fio"
                        label={t('BackOfficeFio')}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs="6">
                    <ValidatedDropDownList<FilterType>
                        name="collectionStatus"
                        items={collectionStatuses}
                        isLoading={getDictsQuery.isFetching}
                        disabled={!collectionStatuses.length}
                        label={t('BackOfficeCollectionStatus')}
                    />
                </Col>
                <Col xs="6">
                    <ValidatedInput<FilterType>
                        id="ds-days-overdue-id"
                        type="number"
                        name="daysOverdue"
                        label={t('BackOfficeOverdueFrom')}
                    />
                </Col>
            </Row>
        </>
    );
};

export default ClientFilter;
